import { FC } from "react";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { setOpenCloseModalPhotos } from "../../../redux/slices/data/dataSampleView";
import { State } from "../../../redux/slices";
import { v4 as uuidv4 } from "uuid";

import moment from "moment";
import { useTranslation } from "react-i18next";
import { selectLocale } from "../../../redux/slices/layout";
import { Alert } from "@mui/material";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    setOpenCloseModalPhotos: (visible: boolean) => {
      dispatch(setOpenCloseModalPhotos(visible));
    },
  };
};

const DataSampleViewLeft: FC = () => {
  const [t] = useTranslation("global");
  const { photos, sampleViewInfo } = useSelector(
    (state: State) => state.DataSampleViewReducer,
  );

  const locale = useSelector(selectLocale);
  const { setOpenCloseModalPhotos } = SetActions();

  const names = sampleViewInfo?.scenarioInstance?.scenario.cerealType.names;

  const creator = sampleViewInfo?.username ? (
    <span className="creator-action-details">{sampleViewInfo.username}</span>
  ) : (
    <span className="creator-action-details">
      {t("Data.SampleView.No_user_info")}
    </span>
  );
  const createdAt = moment(sampleViewInfo?.createdAt);
  createdAt.locale(locale);
  const createdAtModify = createdAt.format("l, LT");
  const locationName = sampleViewInfo?.geoPointName
    ? sampleViewInfo?.geoPointName
    : t("Data.table.No_geo_point");
  const deviceName = sampleViewInfo?.pastAction?.device?.orgInternalId;

  const texts = sampleViewInfo?.texts as { [key: string]: string } | undefined;
  const cropTextId = sampleViewInfo?.cropTextId;
  const scenarioNameTextId = sampleViewInfo?.scenarioNameTextId;

  const findTheName = (textId: number | undefined) => {
    if (!texts || !textId) return "";
    return texts[textId.toString()];
  };

  return (
    <div className="details-left-side">
      <div className="origine">
        <div className="title-sections-sample-view">{t("Data.Origin")}</div>
        <div className="action-container">
          <div
            className="action-card"
            style={{
              backgroundColor:
                sampleViewInfo?.cerealType?.iconBackgroundHexColor,
            }}
          >
            <div className="scenario-info-card">
              {findTheName(scenarioNameTextId)},{findTheName(cropTextId)}
            </div>
          </div>
          <div className="action-info">
            {creator}
            <br />
            {createdAtModify}
            <br />
            <span>{locationName}</span>
            <br />
            <span>{deviceName}</span>
          </div>
        </div>
      </div>

      <div className="photos-container">
        <div className="title-sections-sample-view">{t("Data.Photos")}</div>

        <div className="photos-actions">
          {photos.length > 0 ? (
            photos.map((photo: { signedRequest: string }) => (
              <button
                key={`${photo.signedRequest}${uuidv4()}`}
                className="photos-actions-2"
                onClick={() => setOpenCloseModalPhotos(true)}
              >
                <img
                  className="photo-style-cereal"
                  src={photo.signedRequest}
                  alt="cereal"
                />
                <div className="overlay">
                  <div className="text">
                    <ZoomInIcon fontSize="large" />
                  </div>
                </div>
              </button>
            ))
          ) : (
            <Alert severity="warning" className="mt-4">
              {t("Data.SampleView.No_photos")}
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataSampleViewLeft;
